import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import ImageCardLine from 'src/components/molecules/ImageCardLine'
import ColorButton from 'src/components/atoms/ColorButton'
import SPSlider from 'src/components/molecules/SpSlider'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Image } from 'src/components/atoms/Image'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { Typography } from 'src/components/atoms/Typography'

const clientLogos = [
  { logoName: 'sharp', name: 'シャープ株式会社' },
  { logoName: 'misumi', name: '株式会社ミスミグループ本社' },
  { logoName: 'tandg', name: '株式会社テイクアンドギヴ・ニーズ' },
  { logoName: 'usacsystem', name: 'ユーザックシステム株式会社' },
  { logoName: 'nissan', name: '日産自動車株式会社' },
  { logoName: 'tvtokyo', name: '株式会社テレビ東京' },
  { logoName: 'proseed', name: '株式会社プロシード' },
  { logoName: 'mikawaya21', name: 'MIKAWAYA21株式会社' },
  { logoName: 'pococha', name: 'ポコチャ（株式会社ディー・エヌ・エー）' },
  { logoName: 'hennge', name: 'HENNGE株式会社' },
  { logoName: 'wingarc', name: 'ウイングアーク１ｓｔ株式会社' },
  { logoName: 'nexway', name: '株式会社ネクスウェイ' },
  { logoName: 'infomart', name: '株式会社インフォマート' },
  {
    logoName: 'lifeandworkdesign',
    name: 'ビジネスエアポート（ライフ&ワークデザイン株式会社）'
  },
  { logoName: 'basefood', name: 'ベースフード株式会社' },
  { logoName: 'obc', name: '株式会社オービックビジネスコンサルタント' },
  {
    logoName: 'densocreate',
    name: 'TIME TRACKER（株式会社デンソークリエイト）'
  },
  { logoName: 'rozetta', name: '株式会社ロゼッタ' },
  { logoName: 'baqet', name: '株式会社バケット' },
  { logoName: 'worksapplications', name: '株式会社ワークスアプリケーションズ' },
  { logoName: 'final', name: '株式会社final' },
  { logoName: 'plazacreate', name: '株式会社プラザクリエイト' },
  { logoName: 'konicaminolta', name: 'コニカミノルタ株式会社' },
  { logoName: 'jal', name: '株式会社日本航空' },
  { logoName: 'qbb', name: '六甲バター' },
  { logoName: 'kawasakifrontale', name: '株式会社川崎フロンターレ' },
  { logoName: 'gakken', name: '株式会社学研プラス' },
  { logoName: 'yahoo', name: 'ヤフー株式会社' },
  { logoName: 'shibuyamiraidesign', name: '一般社団法人渋谷未来デザイン' }
]

const TopClient = ({top}) => {
  const data = useStaticQuery(graphql`
    query {
      sharp: file(relativePath: { eq: "top/logos/sharp.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      misumi: file(relativePath: { eq: "top/logos/misumi.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      tandg: file(relativePath: { eq: "top/logos/tandg.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      usacsystem: file(relativePath: { eq: "top/logos/usacsystem.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      tvtokyo: file(relativePath: { eq: "top/logos/tvtokyo.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nissan: file(relativePath: { eq: "top/logos/nissan.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      proseed: file(relativePath: { eq: "top/logos/proseed.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mikawaya21: file(relativePath: { eq: "top/logos/mikawaya21.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pococha: file(relativePath: { eq: "top/logos/pococha.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hennge: file(relativePath: { eq: "top/logos/hennge.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wingarc: file(relativePath: { eq: "top/logos/wingarc.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      nexway: file(relativePath: { eq: "top/logos/nexway.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      infomart: file(relativePath: { eq: "top/logos/infomart.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lifeandworkdesign: file(
        relativePath: { eq: "top/logos/lifeandworkdesign.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      basefood: file(relativePath: { eq: "top/logos/basefood.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      obc: file(relativePath: { eq: "top/logos/obc.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      densocreate: file(relativePath: { eq: "top/logos/densocreate.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      rozetta: file(relativePath: { eq: "top/logos/rozetta.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      baqet: file(relativePath: { eq: "top/logos/baqet.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      worksapplications: file(
        relativePath: { eq: "top/logos/worksapplications.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      final: file(
        relativePath: { eq: "top/logos/final.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      plazacreate: file(
        relativePath: { eq: "top/logos/plazacreate.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      konicaminolta: file(
        relativePath: { eq: "top/logos/konicaminolta.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      jal: file(
        relativePath: { eq: "top/logos/jal.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      qbb: file(
        relativePath: { eq: "top/logos/qbb.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      kawasakifrontale: file(
        relativePath: { eq: "top/logos/kawasakifrontale.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      shibuyamiraidesign: file(
        relativePath: { eq: "top/logos/shibuyamiraidesign.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      calbee: file(
        relativePath: { eq: "top/logos/calbee.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      gakken: file(
        relativePath: { eq: "top/logos/gakken.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      yahoo: file(
        relativePath: { eq: "top/logos/yahoo.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      shibuyamiraidesign: file(
        relativePath: { eq: "top/logos/shibuyamiraidesign.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/case/" } }
        sort: { fields: [frontmatter___date], order: DESC }
        limit: 3
        skip: 1
      ) {
        edges {
          node {
            frontmatter {
              companyLogo {
                publicURL
              }
              title
              companyName
              thumbnail {
                publicURL
              }
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `)

  const {
    allMarkdownRemark: { edges: clientData }
  } = data
  const clientCardData = clientData.map(
    ({
      node: {
        fields: { slug: linkTo },
        frontmatter: { title, companyLogo, companyName, thumbnail }
      }
    }) => ({
      ImageTop: thumbnail?.publicURL,
      ImageLogo: companyLogo?.publicURL,
      // 事例記事タイトルから企業名、「」を除く
      title: title.replace(/.*「(.*)」/, '$1'),
      text: `${companyName}様`,
      linkTo
    })
  )

  return (
    <Container>
      <ContentsWrapper>
        <HeadingBorder heading="CLIENTS" />
        <HeadTitle as="h2">企業への導入事例</HeadTitle>
        <Description>
          顧客コミュニケーションの効率化と顧客体験の最適化を目指す企業に選ばれています。
        </Description>
        <ClientLogos>
          {clientLogos.map(clientLogo => {
            const { childImageSharp } = data[clientLogo.logoName]
            const imageFluid = childImageSharp && childImageSharp.fluid
            return (
              <li key={clientLogo.logoName}>
                <Image imageFluid={imageFluid} alt={clientLogo.name} />
              </li>
            )
          })}
        </ClientLogos>
        {top &&
          <ImageCardLine cardData={clientCardData}/> &&
          <SPSlider cardData={clientCardData} top='true'/> &&
          <ButtonWrapper top={top}>
            <ColorButton text="すべての導入事例を見る" to="/case" arrow />
          </ButtonWrapper>
        }
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.section`
  padding: ${Styles.spacing[11]} 0;
  overflow: hidden;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[14]} 0;
  }
`

const Description = styled(Typography)`
  margin: ${Styles.spacing[7]} 0;
  font-size: ${Styles.fontSize[300]};
  line-height: ${Styles.lineHeight[400]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    font-size: ${Styles.fontSize[400]};
  }
`

const ClientLogos = styled.ul`
  display: grid;
  gap: ${Styles.spacing[6]};
  margin: ${Styles.spacing[10]} 0;
  grid-template-columns: repeat(2, 1fr);
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    margin: ${Styles.spacing[11]} 0;
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (min-width: ${BreakPoint.MOBILE_L}) {
    grid-template-columns: repeat(4, 1fr);
    gap: ${Styles.spacing[8]};
  }
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    grid-template-columns: repeat(5, 1fr);
  }
  @media screen and (min-width: ${BreakPoint.LAPTOP}) {
    grid-template-columns: repeat(6, 1fr);
  }
`

const ButtonWrapper = styled.div`
  padding: ${Styles.spacing[11]} 0 0;
  text-align: center;
`
export default TopClient
